import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import {Sabko} from '../App';
import '../style/Formcom.css';

function Education() {
    const navigate=useNavigate();
    const {state,dispatch}=useContext(Sabko);
    const[Value,setValue]=useState({})
    
    const changeVal=(e)=>{
      const name=e.target.name;
      const value=e.target.value;
      setValue((prev)=>({...prev,[name]:value}))
  
    }
  
    const submitPersoal=(e)=>{
      e.preventDefault();
      if(Object.keys(Value).length===0 && !state.User?.Education){
        navigate('/') 
      }else{
        dispatch({type:"EDUCATION_DETAIL",payload:{...Value} });
        navigate('/') 
      }
    }
  return (
    <div className='main'>

        <form className='Homediv'>
            <div className='inputdiv'>
            <label htmlFor='degree' className='inputLabel'>Degree</label>
            <input type='text'  id='degree' name='degree'
             value={(Value.degree)||((Value.degree==="")?(""):(state.User?.Education?.degree) || (""))} 
             className='inputContent' onChange={changeVal}/>
            </div>

            <div className='inputdiv'>
            <label htmlFor='university' className='inputLabel'>University</label>
            <input type='text'  id='university' name='university'
              value={(Value.university)||((Value.university==="")?(""):(state.User?.Education?.university) || (""))}   
              className='inputContent' onChange={changeVal}/>
            </div>

            <div className='inputdiv'>
            <label htmlFor='score' className='inputLabel'>Score</label>
            <input type='email'  id='score' name='score'  
             value={(Value.score)||((Value.score==="")?(""):(state.User?.Education?.score) || (""))} 
              className='inputContent'  onChange={changeVal}/>
            </div>        

            <div className='inputdiv'>
            <label htmlFor='year'  className='inputLabel'>Year</label>
            <input type='text' id='year' name='year'
             value={(Value.year)||((Value.year==="")?(""):(state.User?.Education?.year) || (""))}              
              className='inputContent'  onChange={changeVal}/> 
            </div>

            <div className='saveDiv'>
            <Button variant="contained" type='submit' className='saveButt' onClick={submitPersoal}>
            Save</Button>
            </div>

        </form>
        </div> 
  )
}

export default Education